import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onToggle", "isMultiSelect", "options", "value", "onChange"];
import React, { memo } from 'react';
import { checkActiveIds } from "../utils/checkActiveIds";
export var withOptionClickingWrapper = function withOptionClickingWrapper(WrappedComponent) {
  return /*#__PURE__*/memo(function (_ref) {
    var onToggle = _ref.onToggle,
      isMultiSelect = _ref.isMultiSelect,
      options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);
    var handleOptionClicked = function handleOptionClicked(option) {
      var activeId = checkActiveIds({
        option: option,
        value: value,
        isMultiSelect: isMultiSelect
      });
      if (!isMultiSelect) {
        onToggle();
      }
      onChange(activeId);
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      isMultiSelect: isMultiSelect,
      onOptionClicked: handleOptionClicked,
      onToggle: onToggle,
      options: options,
      "data-t-id": "Select-hocs"
    }));
  });
};